import { StringSchema } from 'yup'

function atLeastOneCharacter(this: StringSchema, message: string) {
  return this.test('atLeastOneCharacter', message, (value) => /[a-z]+/i.test(value))
}

export default atLeastOneCharacter
